import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';

/**
 * Generated class for the CoTcModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-co-tc-modal',
  templateUrl: 'co-tc-modal.html',
})
export class CoTcModalPage {

  url: string;
  constructor(public navCtrl: NavController, public navParams: NavParams, private events : Events, private timeout : TimeoutFunctionsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.url = this.navParams.data.url;
  }
}



// WEBPACK FOOTER //
// ./src/pages/co-tc-modal/co-tc-modal.ts